import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "yellow"
}
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  type: "submit",
  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition"
}
const _hoisted_8 = {
  key: 2,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_9 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 divide-y divide-gray-100" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "text-sm font-semibold text-gray-900 hover:text-blue-700" }
const _hoisted_12 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-gray-400 mt-0.5"
}
const _hoisted_14 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "forum"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('forum.title')), 1 /* TEXT */),
        ($props.signedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = $event => ($setup.showNewTopic = true)),
              class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
            }, _toDisplayString($setup.t('forum.new_topic')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" New topic form "),
      ($setup.showNewTopic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.createTopic, ["prevent"]),
              class: "flex gap-3"
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newTopicTitle) = $event)),
                type: "text",
                placeholder: $setup.t('forum.topic_title_placeholder'),
                required: "",
                class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              }, null, 8 /* PROPS */, _hoisted_6), [
                [_vModelText, $setup.newTopicTitle]
              ]),
              _createElementVNode("button", _hoisted_7, _toDisplayString($setup.t('forum.create')), 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = $event => ($setup.showNewTopic = false)),
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('forum.cancel')), 1 /* TEXT */)
            ], 32 /* NEED_HYDRATION */)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Flash "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Topics list "),
      ($props.topics.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.t('forum.no_topics')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.topics, (topic, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: topic.id,
            class: _normalizeClass(['p-4 hover:bg-blue-50 transition flex items-center justify-between', index % 2 === 1 ? 'bg-blue-50' : 'bg-white'])
          }, [
            _createElementVNode("a", {
              href: `/forum/${topic.id}`,
              class: "flex-1"
            }, [
              _createElementVNode("h3", _hoisted_11, _toDisplayString(topic.title), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_12, _toDisplayString(topic.user.name) + " · " + _toDisplayString($setup.formatDate(topic.created_at)) + " · " + _toDisplayString(topic.messages_count) + " " + _toDisplayString($setup.t('forum.messages')), 1 /* TEXT */),
              (topic.last_message)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString($setup.t('forum.last_message')) + ": " + _toDisplayString(topic.last_message.user_name) + " · " + _toDisplayString($setup.formatDateTime(topic.last_message.created_at)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_10),
            (topic.user.id === $props.userId || $props.userAdmin)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: $event => ($setup.deleteTopic(topic)),
                  class: "text-xs text-red-400 hover:text-red-600 ml-4"
                }, _toDisplayString($setup.t('forum.delete')), 9 /* TEXT, PROPS */, _hoisted_14))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}